import * as Yup from "yup";
import { DEFAULT_LANGUAGE } from "@/constant/Languages/language";
import {
  BOOLEAN_OPTIONS,
  booleanOptionLabels,
} from "@/constant/GeneralOptions/boolean";

const booleanOptionLabelsMap = booleanOptionLabels();
const boLabelYes = booleanOptionLabelsMap[BOOLEAN_OPTIONS.YES];
const boLabelNo = booleanOptionLabelsMap[BOOLEAN_OPTIONS.NO];

const EventSchema = (
  localeCodes,
  isEdit = false,
  targetLang = DEFAULT_LANGUAGE
) =>
  Yup.object().shape({
    competition_id: Yup.string()
      .label("Competition")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    term_id: Yup.string()
      .label("Term")
      .max(50)
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),

    host_country: Yup.string().label("Host Country").nullable(),
    start_date: Yup.date().label("Start Date").nullable(),
    end_date: Yup.date().label("End Date").nullable(),
    final_city: Yup.string().label("Final City").nullable(),
    final_stadium: Yup.string().label("Final Stadium").nullable(),
    sub_title: Yup.string().label("Sub Title").required().max(120),
    content: Yup.string().label("Content").required(),
    show_in_profile: Yup.boolean()
      .label("Show Profile")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Show Profile must be one of the following values: ${Object.values(
          booleanOptionLabels
        ).join(", ")}`
      ),
    thumbnail_url: Yup.mixed().label("Thumbnail Image").nullable(),
    banner_url: Yup.mixed().label("Banner Image").nullable(),
    auto_translate: Yup.bool()
      .label("Translate All")
      .nullable()
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Translate All must be one of the following values: ${boLabelYes}, ${boLabelNo}`
      ),
  });

export default EventSchema;
